<div class="columns is-centered">
  <div class="column is-8">
    <nav
      class="navbar is-primary is-bold has-text-weight-medium has-shadow mb-3"
      role="navigation"
      aria-label="Main navigation"
      id="nav"
    >
      <div class="container px-3">
        <div class="navbar-brand">
          <a routerLink="/" class="navbar-item">Currency Converter</a>
          <div id="burger" class="navbar-burger" data-target="navbarMenu">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div class="navbar-menu is-pulled-right" id="nav-links">
          <div class="navbar-end">
            <a class="has-text-white-ter has-background-primary" routerLink="/about">About</a>
          </div>
        </div>
      </div>
    </nav>
  </div>
</div>

